/** @format */

import { register } from 'register-service-worker';
import { notificationBus } from '@/libs/notificationBus';

if (process.env.NODE_ENV === 'production') {
  let refreshing = false; // 👈 защита от loop

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.');
    },

    registered(registration) {
      console.log('Service worker has been registered.');
      window.__swRegistration = registration; // 👈 сохранили
      // 🔥 защита от бесконечного reload
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });

      // 🔥 если уже есть waiting (обновление после загрузки)
      if (registration.waiting) {
        notifyUpdate(registration);
      }
    },

    cached() {
      console.log('Content cached for offline use.');
    },

    updatefound() {
      console.log('New content is downloading.');
    },

    updated(registration) {
      console.log('New content is available.');
      notifyUpdate(registration);
    },

    offline() {
      console.log('Offline mode.');
    },

    error(error) {
      console.error('SW registration error:', error);
    },
  });

  // -------------------- helper --------------------

  function notifyUpdate(registration) {
    // 🔥 защита от дублей
    if (window.__swNotified) return;
    window.__swNotified = true;

    setTimeout(() => {
      notificationBus.$emit('newVersionAvailable', { registration });
    }, 500);
  }
}
